import { AssistantLauncher } from '../assistant/AssistantLauncher';
import { useInvoiceTools } from '../hooks/useInvoiceTools';
import { EmissionModeToggle } from './EmissionModeToggle';

/**
 * El asistente y el switch de prueba arriba a la derecha de las pantallas de facturación.
 * Los dos van detrás de su bandera: sin ninguna encendida no se pinta nada, ni el hueco.
 */
export const InvoiceTools = ({ showEmissionMode = true }: { showEmissionMode?: boolean }) => {
  const { withEmissionMode, any } = useInvoiceTools(showEmissionMode);
  if (!any) return null;

  return (
    <div className='flex items-center justify-end gap-2 px-4 pt-3 md:px-6'>
      <AssistantLauncher />
      {withEmissionMode && <EmissionModeToggle />}
    </div>
  );
};
